var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2 14H19.8c-1 0-1.8.75-1.8 1.68v19.65c0 .92.8 1.67 1.8 1.67h10.4c1 0 1.8-.75 1.8-1.67V15.68c0-.93-.8-1.68-1.8-1.68zM25 35a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm5-3H20V17h10v15z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
});